export default __webpack_public_path__ + "static/media/logo-MyPortalCampus-letters.d0d60974.svg";